import { Injectable } from '@angular/core';
import { environment } from '@env';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SerialDevice } from '@modules/private/models/serial-device';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@core/modules/user/services/user.service';
import { User } from '@core/modules/user/models';
import { AuthService } from '@core/modules/authentication/services/auth.service';

@Injectable({
  providedIn: 'any'
})
export class CaptivePortalService {
  API_URL = environment.api;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private userService: UserService,
    private authService: AuthService
  ) {}

  updateUser(user: User): Observable<any> {
    return this.userService.updateUser(user);
  }

  updateTokenLanguage(langId: number): Observable<string> {
    return this.authService.updateTokenLanguage({ langId });
  }

  getInterests(): Observable<any> {
    return this.http.get(this.API_URL + 'interests').pipe(
      map((response) => {
        (response as Array<any>).map((r) => {
          r.interest.name = this.translate.instant(r.interest.name);
        });
        return response;
      })
    );
  }

  getProffesions(): Observable<any> {
    return this.http.get(this.API_URL + 'users/professions/all');
  }

  getInterestsDevice(device: number): Observable<any> {
    return this.http.get(this.API_URL + 'interests/device/' + device);
  }

  getDevice(id: number): Observable<any> {
    return this.http.get(this.API_URL + 'devices/' + id);
  }

  getUserDevice(id: number): Observable<any> {
    return this.http.get(this.API_URL + 'users/' + id + '/devices');
  }

  getInterestsDevices(devices: number[]): Observable<{ id: number; name: string }[]> {
    return this.http
      .get<{ interest: { id: number; name: string } }[]>(`${this.API_URL}interests/devices`, {
        params: { ids: devices }
      })
      .pipe(map((response) => response.map((r) => r.interest)));
  }
}
